
import debounce from 'debounce-async';
import {
  ApiApplicationErrorCodes,
  getApplicationError,
} from '@/utils/behavior/apiErrors';
import { portfolioUniqueNameError } from '~/utils/behavior/portfolio-creation';
import CustomModal from '../molecule/CustomModal.vue';
import { mapGetters } from 'vuex';
import { LeagueDisplayModes } from '~/utils/constants/leagueConstants';

import CloseIcon from '../icons/CloseIcon.vue';
// import LeagueCard from '../molecule/LeagueCard.vue';
import CalendarIcon from '../icons/CalendarIcon.vue';
import CreatePortfolioInfoCard from '../molecule/CreatePortfolioInfoCard.vue';

export default {
  name: 'UICreateLeaguePortfolioModal',
  components: {
    CustomModal,
    CloseIcon,
    // LeagueCard,
    CalendarIcon,
    CreatePortfolioInfoCard,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledReason: {
      type: String,
      default: null,
    },
  },
  emits: ['onClose', 'onSubmit'],
  data() {
    return {
      name: '',
      error: '',
      formValues: {
        name: '',
        type: 'classic',
        date: '',
        referralCode: '',
      },
      debouncedValidatePortfolioName: debounce(this.validatePortfolioName, 500),
      portfolioNameValiadtionMessages: {
        required: this.$t('name_required'),
        max: this.$t('name_max_length', { max: 24 }),
        'back-end': this.$t('error_occured_message'),
      },
      displayModes: LeagueDisplayModes,
    };
  },

  computed: {
    ...mapGetters('modals', ['createPortfolioModal']),
    ...mapGetters('authentication', ['isEmailConfirmed']),
    league() {
      return this.createPortfolioModal?.league;
    },
    initialDate() {
      const today = this.$dayjs().$d.getDay();
      // getDay() returns 0-6 (SUNDAY IS 0!!!)
      let toSubstract = 1;
      if (today === 1) {
        toSubstract = 3;
      } else if (today === 0) {
        toSubstract = 2;
      }
      const res = this.$dayjs()
        .subtract(toSubstract, 'day')
        .format('YYYY-MM-DD');
      return res;
    },
    uniqueNameError() {
      return portfolioUniqueNameError;
    },
    limitReachedError() {
      return portfolioLimitReachedError;
    },
    minLinesToEnterRankings() {
      return this.league.minLinesToEnterRankings;
    },
  },
  created() {
    this.formValues.date = this.initialDate;
  },
  methods: {
    submit() {
      if (this.disabled) return;
      const payload = {
        ...this.formValues,
      };
      this.$emit('onSubmit', payload);
    },
    onClose(index) {
      this.formValues.cashAmounts.splice(index, 1);
    },
    async validatePortfolioName(name) {
      try {
        await this.$api.validatePortfolioName(name);
        return true;
      } catch (e) {
        const apiError = getApplicationError(e.response.data.errorCode);

        console.error('e', e);

        // expand this switch statement as needed
        switch (apiError) {
          // if the profile has another portfolio with the same name, show the error message
          case ApiApplicationErrorCodes.BadRequest.UniquePortfolioName:
            this.portfolioNameValiadtionMessages['back-end'] = this.$t(
              portfolioUniqueNameError
            );
            return false;
          // since we have the length validation in the front-end, we don't need to handle that error type here, so return true
          case ApiApplicationErrorCodes.BadRequest
            .PortfolioNameExceedsMaximumCharacters:
            return true;
          // if there is an error that we have not handled, we can show a generic error message
          default:
            // showing special error message in case the email is not verified
            if (!this.isEmailConfirmed && e.response.status === 403) {
              this.portfolioNameValiadtionMessages['back-end'] = this.$t(
                'portfolio_email_not_verified_error'
              );
              return false;
            }
            this.portfolioNameValiadtionMessages['back-end'] = this.$t(
              'error_occured_message'
            );
            return false;
        }
      }
    },
    // Might be the best if we moved this logic to LeagueCard or some other smaller component and just pass in the date as a prop
    remainingTimeString(date) {
      const now = this.$dayjs();
      const end = this.$dayjs(date);
      const hrs = end.diff(now, 'hour', true);
      return Math.max(0, Math.floor(hrs));
    },
    handleCloseModal() {
      this.$emit('onClose');
    },
  },
};
